<template>
  <div v-if="loaded">
    <div class="flex justify-center flex-wrap relative grey-bg">
      <div v-if="wallets.value && wallets.value.items.length" class="col-12">
        <!-- LISTS OF WALLETS -->
        <Wallets />
      </div>
      <div v-else class="flex justify-center pt3 mx2">
        <div class="col-12 md-col-8 flex justify-center flex-wrap">
          <i class="icon-stop" style="font-size: 50px"></i>
          <p>{{ getReferencelabel("WALLET_INFO_1") }}</p>
          <p> {{ getReferencelabel("WALLET_INFO_2") }}</p>
        </div>
      </div>
    </div>
    <div v-if="routeMatchesComponent()" class="col-12 px4 flex py1 justify-center">
      <Button
        v-if="showButton"
        reference="CREATE_NEW_WALLET"
        class="col-9 md-col-4 pb2"
        btn-color="blue"
        :action="goToForm"
      />
    </div>
  </div>
</template>

<script>

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import Wallets from '@/components/services/Wallets.vue';
import Button from '@/components/elements/Button';
import { getWallets, getCenters } from '@/mixins/requests';
import { getReferencelabel, routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: {
    Wallets,
    Button
  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const wallets = reactive({});
    const loaded = ref(false);

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const showButton = computed(() => {
      const disableFeatures = store.getters.getSiteConfiguration('disabled_features');
      if (disableFeatures.includes('nouveau-wallet')) {
        return false;
      }

      return true;
    });

    function goToForm () {
      router.push({ name: 'AddWallet' });
    }

    async function syncWallets () {
      wallets.value = await getWallets();
      const sortedWallets = wallets && wallets.value.items ? wallets.value.items.sort(w => w.holder.uuid === store.state.user.uuid) : [];
      store.commit('setWallets', sortedWallets);
      loaded.value = true;
    }

    async function syncCenters () {
      const centersList = await getCenters();
      store.commit('setCenters', centersList.items);
    }

    onMounted(async () => {
      store.commit('setLoading', true);
      await syncCenters();
      await syncWallets();
      store.commit('setLoading', false);
    });

    return { wallets, route, showButton, loaded, goToForm, getReferencelabel, routeMatchesComponent };
  }
};
</script>

<style lang="scss"></style>
